import { parseStringToArray } from './parseStringToArray';
const periodicTableGrid = [
    [
        { name: 'H', color: 'lightGray', text: '' },
        { name: '', color: '', text: '' },
        { name: 'D', color: 'lightGray', text: '' },
        { name: 'T', color: 'lightGray', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: 'He', color: 'yellow', text: '' },
    ],
    [
        { name: 'Li', color: 'pink', text: '' },
        { name: 'Be', color: 'pink', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: 'B', color: 'lightGreen', text: '' },
        { name: 'C', color: 'blueGray', text: '' },
        { name: 'N', color: 'blueGray', text: '' },
        { name: 'O', color: 'blueGray', text: '' },
        { name: 'F', color: 'orange', text: '' },
        { name: 'Ne', color: 'yellow', text: '' },
    ],
    [
        { name: 'Na', color: 'pink', text: '' },
        { name: 'Mg', color: 'pink', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: 'Al', color: 'gray', text: '' },
        { name: 'Si', color: 'lightGreen', text: '' },
        { name: 'P', color: 'blueGray', text: '' },
        { name: 'S', color: 'blueGray', text: '' },
        { name: 'Cl', color: 'orange', text: '' },
        { name: 'Ar', color: 'yellow', text: '' },
    ],
    [
        { name: 'K', color: 'pink', text: '' },
        { name: 'Ca', color: 'pink', text: '' },
        { name: 'Sc', color: 'blue', text: '' },
        { name: 'Ti', color: 'blue', text: '' },
        { name: 'V', color: 'blue', text: '' },
        { name: 'Cr', color: 'blue', text: '' },
        { name: 'Mn', color: 'blue', text: '' },
        { name: 'Fe', color: 'blue', text: '' },
        { name: 'Co', color: 'blue', text: '' },
        { name: 'Ni', color: 'blue', text: '' },
        { name: 'Cu', color: 'blue', text: '' },
        { name: 'Zn', color: 'blue', text: '' },
        { name: 'Ga', color: 'gray', text: '' },
        { name: 'Ge', color: 'lightGreen', text: '' },
        { name: 'As', color: 'lightGreen', text: '' },
        { name: 'Se', color: 'blueGray', text: '' },
        { name: 'Br', color: 'orange', text: '' },
        { name: 'Kr', color: 'yellow', text: '' },
    ],
    [
        { name: 'Rb', color: 'pink', text: '' },
        { name: 'Sr', color: 'pink', text: '' },
        { name: 'Y', color: 'blue', text: '' },
        { name: 'Zr', color: 'blue', text: '' },
        { name: 'Nb', color: 'blue', text: '' },
        { name: 'Mo', color: 'blue', text: '' },
        { name: 'Tc', color: 'blue', text: '' },
        { name: 'Ru', color: 'blue', text: '' },
        { name: 'Rh', color: 'blue', text: '' },
        { name: 'Pd', color: 'blue', text: '' },
        { name: 'Ag', color: 'blue', text: '' },
        { name: 'Cd', color: 'blue', text: '' },
        { name: 'In', color: 'gray', text: '' },
        { name: 'Sn', color: 'gray', text: '' },
        { name: 'Sb', color: 'lightGreen', text: '' },
        { name: 'Te', color: 'lightGreen', text: '' },
        { name: 'I', color: 'orange', text: '' },
        { name: 'Xe', color: 'yellow', text: '' },
    ],
    [
        { name: 'Cs', color: 'pink', text: '' },
        { name: 'Ba', color: 'pink', text: '' },
        { name: '', color: 'lightBlue', text: '*' },
        { name: 'Hf', color: 'blue', text: '' },
        { name: 'Ta', color: 'blue', text: '' },
        { name: 'W', color: 'blue', text: '' },
        { name: 'Re', color: 'blue', text: '' },
        { name: 'Os', color: 'blue', text: '' },
        { name: 'Ir', color: 'blue', text: '' },
        { name: 'Pt', color: 'blue', text: '' },
        { name: 'Au', color: 'blue', text: '' },
        { name: 'Hg', color: 'blue', text: '' },
        { name: 'Tl', color: 'gray', text: '' },
        { name: 'Pb', color: 'gray', text: '' },
        { name: 'Bi', color: 'gray', text: '' },
        { name: 'Po', color: 'lightGreen', text: '' },
        { name: 'At', color: 'orange', text: '' },
        { name: 'Rn', color: 'yellow', text: '' },
    ],
    [
        { name: 'Fr', color: 'pink', text: '' },
        { name: 'Ra', color: 'pink', text: '' },
        { name: '', color: 'green', text: '**' },
    ],
    [
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: 'La', color: 'lightBlue', text: '' },
        { name: 'Ce', color: 'lightBlue', text: '' },
        { name: 'Pr', color: 'lightBlue', text: '' },
        { name: 'Nd', color: 'lightBlue', text: '' },
        { name: 'Pm', color: 'lightBlue', text: '' },
        { name: 'Sm', color: 'lightBlue', text: '' },
        { name: 'Eu', color: 'lightBlue', text: '' },
        { name: 'Gd', color: 'lightBlue', text: '' },
        { name: 'Tb', color: 'lightBlue', text: '' },
        { name: 'Dy', color: 'lightBlue', text: '' },
        { name: 'Ho', color: 'lightBlue', text: '' },
        { name: 'Er', color: 'lightBlue', text: '' },
        { name: 'Tm', color: 'lightBlue', text: '' },
        { name: 'Yb', color: 'lightBlue', text: '' },
        { name: 'Lu', color: 'lightBlue', text: '' },
    ],
    [
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: '', color: '', text: '' },
        { name: 'Ac', color: 'green', text: '' },
        { name: 'Th', color: 'green', text: '' },
        { name: 'Pa', color: 'green', text: '' },
        { name: 'U', color: 'green', text: '' },
        { name: 'Np', color: 'green', text: '' },
        { name: 'Pu', color: 'green', text: '' },
        { name: 'Am', color: 'green', text: '' },
        { name: 'Cm', color: 'green', text: '' },
        { name: 'Bk', color: 'green', text: '' },
        { name: 'Cf', color: 'green', text: '' },
        { name: 'Es', color: 'green', text: '' },
        { name: 'Fm', color: 'green', text: '' },
        { name: 'Md', color: 'green', text: '' },
        { name: 'No', color: 'green', text: '' },
        { name: 'Lr', color: 'green', text: '' },
    ],
];
const elementNames = periodicTableGrid
    .flat()
    .map((element) => element.name)
    .filter(Boolean);
const isElementValid = (name) => elementNames.includes(name);
const getValidElementSymbols = (value) => {
    const namesInString = parseStringToArray(value).filter((name) => isElementValid(name));
    return [...new Set(namesInString)].join(', ');
};
const hasInvalidElementSymbol = (string) => {
    const namesInString = parseStringToArray(string);
    return namesInString.some((name) => !isElementValid(name));
};
export { periodicTableGrid, elementNames, getValidElementSymbols, hasInvalidElementSymbol, parseStringToArray };
